import { Injectable, computed, inject } from '@angular/core';
import { catchError, first, map, mergeMap, of } from 'rxjs';
import { EffectsBase, mergeTwoObjects } from 'clicklease-ui-elements';
import { RoseService } from './../../services';
import {
    BusinessInfoFormSelector,
    BusinessWritableInformationSelector,
    BusinessInformationIdSelector,
    getRoseKeySelector,
    LoadBusinessInfoFormAction,
    SetSubmittingBusinessInfoAction,
    SetSubmittingBusinessInfoErrorAction,
} from './../../ngrx';

@Injectable()
export class BusinessInfoEffectsService extends EffectsBase {
    readonly #roseService = inject(RoseService);
    readonly #businessId = this.store.selectSignal(
        BusinessInformationIdSelector
    );
    readonly #businessInfo = this.store.selectSignal(
        BusinessWritableInformationSelector
    );
    readonly #businessFormInfo = this.store.selectSignal(
        BusinessInfoFormSelector
    );
    readonly #roseKey = this.store.selectSignal(getRoseKeySelector);
    readonly #newBusinessInfo = computed(() =>
        mergeTwoObjects(this.#businessInfo(), this.#businessFormInfo())
    );

    public readonly submitBusinessInfoForm = this.createEffect(() =>
        this.actions.pipe(
            this.ofType(LoadBusinessInfoFormAction),
            mergeMap(() => this.updateBusinessInfo())
        )
    );

    private updateBusinessInfo() {
        return this.#roseService
            .updateBusinessInfo(
                this.#roseKey(),
                this.#businessId(),
                this.#newBusinessInfo()
            )
            .pipe(
                map(() => SetSubmittingBusinessInfoAction()),
                catchError(() => of(SetSubmittingBusinessInfoErrorAction())),
                first()
            );
    }
}
